import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAppContext, authenticateUser, signOut } from "api/ContextAPI";
import { AppThunk } from "app/store";
import { RootState } from "app/rootReducer";
import { stat } from "fs";
import { RequestMist } from "api/MistingRequest";

interface ContextState {
  isAuthenticated: Boolean | undefined;
  user: User | undefined;
  loading: boolean;
  error: string | null;
}

type User = {
  id: number;
  username: string;
};

const initialState: ContextState = {
  isAuthenticated: undefined,
  user: undefined,
  loading: false,
  error: null,
};

const context = createSlice({
  name: "context",
  initialState,
  reducers: {
    setLoginPending(state: ContextState) {
      state.loading = true;
      state.error = null;
    },
    setLoginSuccess(state, action: PayloadAction<any>) {
      var user = action.payload;

      return {
        ...state,
        loading: false,
        isAuthenticated: user && user.id > 0 ? true : false,
        user: user,
      };
    },
    setLoginFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    signOutSuccess(state) {
      return {
        ...initialState,
      };
    },
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
  },
});

export const {
  setLoginPending,
  setLoginSuccess,
  setLoginFailed,
  setLoading,
  signOutSuccess,
  setIsAuthenticated,
} = context.actions;

/**
 * Selectors
 */
// Is authenticated selector
export const isAuthenticated = (state: RootState) =>
  state.context.isAuthenticated;

// Get login message
export const error = (state: RootState) => state.context.error;

export const getUser = (state: RootState) => state.context.user;

export default context.reducer;

// Thunks
export const authenticate = (
  username: string,
  password: string
): AppThunk => async (dispatch: any) => {
  dispatch(setLoginPending);

  authenticateUser(username, password)
    .then((response) => {
      if (response && response.successful) {
        getAppContext().then((response) => dispatch(setLoginSuccess(response)));
      } else {
        dispatch(
          setLoginFailed(
            !response?.successful ? response.message : "Unable to login"
          )
        );
      }
    })
    .catch((e) => {
      dispatch(setLoginFailed("Unable to login"));
    });
};

export const getAppContextThunk = (): AppThunk => async (dispatch: any) => {
  try {
    const appContext = await getAppContext();

    dispatch(setLoginSuccess(appContext));
  } catch (e) {
    dispatch(setIsAuthenticated(false));
  }
};

export const signOutThunk = (): AppThunk => async (dispatch: any) => {
  dispatch(setLoading(true));

  signOut().then(() => {
    dispatch(signOutSuccess());
    dispatch(setLoading(false));
  });
};

//TODO: move to its own thunk file probably in a mist folder
export const RequestMistingThunk = (duration: number): AppThunk => async (
  dispatch: any
) => {
  console.log("I should send a mist for", duration);
  // Request the mist
  await RequestMist(duration);

  // Maybe do a notification thing?
};
